<div class="div-subscription mat-elevation-z8">
    @if (useProduct) {
        @if ((product$ | async)?.subscriptions?.length! > 0) {
            <table mat-table [dataSource]="(product$ | async)!.subscriptions!" class="mat-elevation-z8">
                <ng-container matColumnDef="CloudUserId">
                    <th mat-header-cell *matHeaderCellDef> Cloud-User-ID</th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'highlighted': element.cloudUserMail === userMail}"> {{ element.cloudUserMail ?? "N/A" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Language">
                    <th mat-header-cell *matHeaderCellDef> Language</th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'highlighted': element.cloudUserMail === userMail}"> {{ element.subscriptionLanguage?.name ?? "N/A" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="CreatedBy">
                    <th mat-header-cell *matHeaderCellDef> Created By</th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'highlighted': element.cloudUserMail === userMail}"> {{ element.createdBy ?? "N/A" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="CreatedOn">
                    <th mat-header-cell *matHeaderCellDef> Created On</th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'highlighted': element.cloudUserMail === userMail}">
                        @if (element.createdOn) {
                            {{ (element.createdOn | date) }}
                        } @else {
                            N/A
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element"
                        [ngClass]="{'highlighted': element.cloudUserMail === userMail}">
                        <button matTooltip="Delete Subscription" mat-fab color="warn" class="button-icon"
                                (click)="deleteProductSubscription(element)"
                                [disabled]="element.cancellationToken=='initial'">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columns;"></tr>
            </table>
        } @else {
            <p class="available">No Subscriptions available</p>
        }
    } @else {
        @if ((userSubscriptions$ | async)?.length! > 0) {
            <table mat-table [dataSource]="(userSubscriptions$ | async)!" class="mat-elevation-z8">
                <ng-container matColumnDef="Product">
                    <th mat-header-cell *matHeaderCellDef> Product</th>
                    <td mat-cell *matCellDef="let element"> {{ element.productName ?? "N/A" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Language">
                    <th mat-header-cell *matHeaderCellDef> Language</th>
                    <td mat-cell *matCellDef="let element"> {{ element.subscriptionLanguage?.name ?? "N/A" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="CreatedBy">
                    <th mat-header-cell *matHeaderCellDef> Created By</th>
                    <td mat-cell *matCellDef="let element"> {{ element.createdBy ?? "N/A" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="CreatedOn">
                    <th mat-header-cell *matHeaderCellDef> Created On</th>
                    <td mat-cell *matCellDef="let element"> {{ (element.createdOn | date) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <button matTooltip="Delete Subscription" mat-fab color="warn" class="button-icon"
                                (click)="deleteSubscription(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns2; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: columns2;"></tr>
            </table>
        } @else {
            <p class="available">No Subscriptions available</p>
        }
    }
</div>



